export default "/_next/static/images/a069ceee584586502c87cd71704f4264.jpg";